import React from 'react';
import ReactDOM from 'react-dom';
import { TreeSelect, Form } from 'antd';
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun"
const TreeNode = TreeSelect.TreeNode;
const FormItem = Form.Item;
import { uuid } from "rt-sd-common/sgiCommon/sgiCommon";
import { StandardCode } from 'rt-sd-common/sgiFactory/StandardCode';
import { getPropsFromItem } from './SgiCompComm';
import { getConstByKey } from './sgiBaseComp/SgiCommon';
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const treeConfConstant = {
    childrenName: 'cldSet'
}
/**
 * 下拉树-wangj
 */
class SgiFormTreeSelect extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号


    constructor(props) {
        super(props);
        //初始化state
        this.initState();
        this.state.displayField = '';
        this.state.saveField = '';
        this.state.childrenName = treeConfConstant.childrenName;
        this.state.treeData = [];
        // this.state.value = undefined;

        // 订阅标准代码更新
        let scId = (this.props.moduleDesc || {}).scId;
        if (scId) this.state.unsubscribe_sc = StandardCode.subscribe(scId, (newSCList) => {
            if (!newSCList) return;
            this.setState({ treeData: newSCList });
        });

        var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
        //组装属性
        this.treeSelect_mk(parentModule, moduleDesc, bdInst, objFct, type);
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {对象工厂} objFct
     * @param {make类型} type
     */
    treeSelect_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }
        //绑定数据，创建表格store 搜索条、翻页控件需要使用该信息，所以先创建
        var tableStore = this.getTreeData(moduleDesc, objFct);
        this.state.treeData = tableStore;
        //显示信息
        //    this.state.displayField = moduleDesc.c ? moduleDesc.c : 'te';
        //转换基础属性
        this.AddTreeAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //转换form公共属性
        AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定值
        bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
    }


    dynamicRefreshCombox(newlist, codeCode, textCode, childCode) {
        this.state.displayField = textCode;
        this.state.saveField = codeCode;
        this.state.treeData = newlist;
        if (childCode) {
            this.state.childrenName = childCode;
        }
        this.setState({ loading: false });
    }

    /**
     * 组装下拉框内容
     * @param {描述} moduleDesc
     */
    getTreeData(moduleDesc, objFct) {

        // this.state.store = []
        //参数工厂获取标准代码 暂时当获取到了 属性为'sc', 'te', 'c'
        //下面是临时数据
        var scId = moduleDesc.scId; //绑定实例名
        var tData;
        if (scId) {
            // 下拉窗列表值在标准代码中的id
            tData = StandardCode.getSC(scId);
            // this.state.displayField = 'te';
            // this.state.saveField = 'c';
        } else {
            var insName = getConstByKey(this, moduleDesc.insName); //绑定实例名

            //取得绑定类名`  var tData = [];
            if (insName && objFct) {
                tData = objFct.get(insName);
            }
        }
        this.state.displayField = moduleDesc.showKey || 'te';
        this.state.saveField = moduleDesc.saveKey || 'c';
        if (!tData) {
            return [];
        }
        return tData;

    }
    /**
     * 创建树视图
     */
    AddTreeAttribute(moduleDesc, formItem, inputprops) {

        //多选
        if (moduleDesc.mulSel) {
            // inputprops.multiple = moduleDesc.mulSel;
            inputprops.treeCheckable = true;//选择框
            // inputprops.showCheckedStrategy = SHOW_PARENT;
        } else {
            inputprops.multiple = moduleDesc.mulSel;
            inputprops.showSearch = "showSearch";//在下拉中显示搜索框(仅在单选模式下生效)
        }
        // inputprops.value = this.state.treeData;
        // inputprops.placeholder = "请选择";//选择框默认文字
        inputprops.treeDefaultExpandAll = true;//展开所有
        inputprops.allowClear = "inputprops";//允许删除按钮
        inputprops.treeNodeFilterProp = "title";//搜索框设置为标题
        // inputprops.treeCheckStrictly = true;//父子节点受控
        //显示名称
        var showKey = moduleDesc.showKey;
        // if (showKey) inputprops.treeNodeLabelProp = showKey; //treeNodeLabelProp保持默认属性"title"，不能修改，否则名称无法回显
        inputprops.dropdownStyle = { maxHeight: 500, overflow: 'auto' };




        // clpDrt:"top", // 面板的折叠方向
        // clpd:false, // 面板初始时的折叠状态
        // disCustom:false, //只显示自定义菜单
        // isClp:false, // 面板是否可以折叠
        // isClpFst:true, // 是否面板展开或收缩的顺序
        // isCls:false, // 面板是否可以关闭
        // isFrm:false, // 面板是否填充
        // isHClpTl:false, // 是否显示折叠按钮
        // isMsMu:false, //使用右键菜单
        // isTlb:false, //显示工具条
        // isttlClp:false, // 是否单击面板头部折叠
        // tlbIsTtl:true, //显示标题
        // ttlAlg:"top", // 面板标题位置
        // ttlAlgn:"left", // 面板标题对齐方式
        // selFirst:false, //初始化后选择首行
        // 可设置默认选中的树节点：defaultSelectedKeys，（受控）设置选中的树节点：selectedKeys
    }

    // 生成下拉树 treeNodes 数据，
    fitTreeSels = (data) => data.map((item) => {
        let childrenName = this.state.childrenName;

        if (item[childrenName] && item[childrenName].length) {
            return {
                label: (item[this.state.displayField]),
                key: (item[this.state.saveField] || item["_key"] || uuid(8)),
                value: (item[this.state.saveField]),
                itemData: item,
                ...getPropsFromItem(item),
                // disabled: (typeof item._disabled === "boolean") ? item._disabled : undefined,
                // selectable: (typeof item._selectable === "boolean") ? item._selectable : undefined,
                // checkable: (typeof item._checkable === "boolean") ? item._checkable : undefined,
                // disableCheckbox: (typeof item._disableCheckbox === "boolean") ? item._disableCheckbox : undefined,
                children: (this.fitTreeSels(item[childrenName]))
            };
        }
        return {
            label: (item[this.state.displayField]),
            key: (item[this.state.saveField] || item["_key"] || uuid(8)),
            value: (item[this.state.saveField]),
            itemData: item,
            ...getPropsFromItem(item),
            // disabled: (typeof item._disabled === "boolean") ? item._disabled : undefined,
            // selectable: (typeof item._selectable === "boolean") ? item._selectable : undefined,
            // checkable: (typeof item._checkable === "boolean") ? item._checkable : undefined,
            // disableCheckbox: (typeof item._disableCheckbox === "boolean") ? item._disableCheckbox : undefined,
        };
    });

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    getShowValue() {
        var comboBoxData = this.state.treeData;
        if (!comboBoxData) {
            return;
        }
        let value = this.state.inputprops.value;
        var newcomboBoxData = [];
        if (value && !(value instanceof Array)) {
            var valueList = value.split(",");//拆分
            for (var i = 0; i < valueList.length; i++) {
                var uceC = valueList[i];
                newcomboBoxData.push(uceC);
            }
        } else if (value) {
            newcomboBoxData = value;
        }
        let showValue = newcomboBoxData.map(key => this.getShowValueByKey(key));
        return showValue.join(",");
    }
    getShowValueByKey(key, comboBoxData) {
        if (!key) return null;
        comboBoxData = comboBoxData || this.state.treeData;
        if (!comboBoxData) return null;
        for (const item of comboBoxData) {
            if (item[this.state.saveField || "c"] === key) {
                return item[this.state.displayField || "te"];
            } else if (item[this.state.childrenName]) {
                const sonRet = this.getShowValueByKey(key, item[this.state.childrenName]);
                if (sonRet) return sonRet;
            }
        }
    }

    //渲染并返回一个虚拟DOM
    render = function () {
        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.treeSelect_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        let value = this.state.inputprops.value;
        var newcomboBoxData = [];
        if (value && value.indexOf(",") > -1) {
            var valueList = value.split(",");//拆分
            for (var i = 0; i < valueList.length; i++) {
                var uceC = valueList[i];
                newcomboBoxData.push(uceC);
            }
            this.state.inputprops.value = newcomboBoxData;

        } else {
            this.state.inputprops.value = value;
        }

        // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
        const { _inputProps, _formItemProps } = this.getReviseProps();
        const { isLabel } = _inputProps;

        // 渲染前通用处理，如自定义样式等
        this.renderBeforeReturn();

        let showValue = this.getShowValue();
        if (showValue === undefined) showValue = this.state.inputprops.value;

        let ctl = (isLabel)
            ? <span {...this.state.inputprops} {..._inputProps} title={showValue}>{showValue}</span>
            : <TreeSelect  {...this.state.inputprops} {..._inputProps}
                treeData={this.fitTreeSels(this.state.treeData)} />;

        return this.state.noFI ? ctl : <FormItem {...this.state.formItemProps} {..._formItemProps}>{ctl}</FormItem>;
    }

    componentWillUnmount() {
        // 取消标准代码订阅
        let unsubscribe = this.state.unsubscribe_sc;
        if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
    }
}
//给类添加公共方法
Object.assign(SgiFormTreeSelect.prototype, sgiFormCtlBaseFun);
export { SgiFormTreeSelect };
export default SgiFormTreeSelect;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiFormTreeSelect.js